module.exports = __webpack_public_path__ + "static/media/wrong.375cfbe7.png";